export default {
  notaAlumnoExamen: {},
  notaAlumnoExamens: [],
  errorArray: [],
  fields: {},
  record: {
    nuevo: false,
    actualizado: false,
  },
  pagination: {},
};
